import React, { useState } from "react";
import { RiderProductModel } from "../../Api/Models/rider.model";
import { TshirtItem } from "./Exchange";
import { ProductModel } from "../../Api/Models/product.model";
import TshirtIcon from "../../Assets/gfx/tshirt.jpg";
import { t } from "i18next";
import { StockModel } from "../../Api/Models/stock.model";
import { ExchangeLifecycleIcon } from "../Icons/ExchangeLifecycleIcon";
import { CheckIcon } from "../Icons/CheckIcon";
import { LongArrowLeftIcon } from "../Icons/LongArrowLeftIcon";
import Popover from "../Popover";

interface ExchangeTshirtsProps {
  gears: RiderProductModel[];
  returnedTshirts: TshirtItem[];
  setReturnedTshirts: CallableFunction;
  dispatchedTshirts: TshirtItem[];
  setDispatchedTshirts: CallableFunction;
  stocks: StockModel[];
  maxTshirtsCount: { maxTshirts: number; returnModifier: number };
  tShirts: ProductModel[];
  setTShirts: React.Dispatch<React.SetStateAction<ProductModel[]>>;
}

const ExchangeTshirts: React.FunctionComponent<ExchangeTshirtsProps> = ({
  gears,
  returnedTshirts,
  dispatchedTshirts,
  setReturnedTshirts,
  setDispatchedTshirts,
  stocks,
  maxTshirtsCount,
  tShirts,
  setTShirts,
}) => {
  const [showTshirtExchange, setShowTshirtExchange] = useState<boolean>(false);
  const modifyReturnedTshirts = (
    productId: number,
    variationId: number,
    increase: boolean
  ) => {
    if (
      increase &&
      gears.filter(
        (item) =>
          item.productId === productId &&
          item.productVariationId === variationId
      ).length <=
        (returnedTshirts.find(
          (item) =>
            item.productId === productId && item.variationId === variationId
        )?.quantity ?? 0)
    ) {
      return;
    }

    if (!increase) {
      let dispatchedSum = dispatchedTshirts.reduce((accumulator, object) => {
        return accumulator + object.quantity;
      }, 0);

      let returnedSum = returnedTshirts.reduce((accumulator, object) => {
        return accumulator + object.quantity;
      }, 0);

      if (
        dispatchedSum > maxTshirtsCount.maxTshirts &&
        returnedSum - 1 < dispatchedSum - maxTshirtsCount.maxTshirts
      ) {
        return;
      }
    }

    let state = [...returnedTshirts];

    if (
      !state.find(
        (item) =>
          item.productId === productId && item.variationId === variationId
      )
    ) {
      state.push({
        productId,
        variationId,
        quantity: increase ? 1 : 0,
      });
    } else {
      state = state.map((item) =>
        item.productId === productId && item.variationId === variationId
          ? {
              productId,
              variationId,
              quantity: increase
                ? item.quantity + 1
                : Math.max(item.quantity - 1, 0),
            }
          : item
      );
    }

    setReturnedTshirts(state.filter((item) => item.quantity > 0));
  };

  const modifyDispatchedTshirts = (
    productId: number,
    variationId: number,
    increase: boolean
  ) => {

    const variationStock = stocks.find(s => s.variationId === variationId)?.quantity ?? 0;

    const currentQty = dispatchedTshirts.find(
        dt => dt.productId === productId && dt.variationId === variationId
    )?.quantity ?? 0;

    if (increase && currentQty >= variationStock) {
      console.warn("Not enough stock for this variation");
      return;
    }

    let localDispatchedTshirts = [...dispatchedTshirts];

    if (localDispatchedTshirts.find((x) => x.productId !== productId)) {
      localDispatchedTshirts = [];
    }

    const baseQuantity = localDispatchedTshirts.find((x) => x.productId === productId)?.quantity ?? 0;

    localDispatchedTshirts = localDispatchedTshirts.filter((x) => x.productId !== productId);

    let returnedSum = returnedTshirts.reduce((accumulator, object) => {
      return accumulator + object.quantity;
    }, 0);

    let returnModifier = 0;

    if (returnedSum >= maxTshirtsCount.returnModifier) {
      returnModifier = maxTshirtsCount.returnModifier;
    } else {
      returnModifier = returnedSum;
    }

    if (
      increase &&
        localDispatchedTshirts.reduce((accumulator, object) => {
        return accumulator + object.quantity;
      }, 0) >=
        maxTshirtsCount.maxTshirts + returnModifier
    ) {
      return;
    }

    if (
      !localDispatchedTshirts.find(
        (item) =>
          item.productId === productId && item.variationId === variationId
      )
    ) {
      localDispatchedTshirts.push({
        productId,
        variationId,
        quantity: Math.min(maxTshirtsCount.maxTshirts + returnModifier, Math.max(baseQuantity + (increase ? 1 : -1), 0)),
      });
    } else {
      localDispatchedTshirts = localDispatchedTshirts.map((item) =>
        item.productId === productId && item.variationId === variationId
          ? {
              productId,
              variationId,
              quantity: increase
                ? item.quantity + 1
                : Math.max(item.quantity - 1, 0),
            }
          : item
      );
    }

    setDispatchedTshirts(localDispatchedTshirts.filter((item) => item.quantity > 0));
  };
  const isProductInStock = (tshirt: ProductModel): boolean => {
    return tshirt.variations.some((variation) => {
      const matchingStock = stocks.find((stock) => stock.variationId === variation.id);
      return matchingStock && matchingStock.quantity > 0;
    });
  };


  const isSaveDisabled = dispatchedTshirts.some(dt => {
    const product = tShirts.find(t => t.id === dt.productId);
    return !product?.selectedVariationId;
  });




  return (
    <>
      <div
        className={"modal" + (!showTshirtExchange ? " hidden" : "")}
        tabIndex={-1}
        aria-modal="true"
        role="dialog"
      >
        <div className="modal__dialog modal-dialog--full-height">
          
          <div className="modal__body">


            <div className="navigationbar navigationbar--dark mb-6">
              <div className="navigationbar__left">
                <span onClick={() => {setShowTshirtExchange(false)}} className="navigationbar__button">
                  <LongArrowLeftIcon />
                </span>
              </div>
              <div className="navigationbar__center">
                <div className="navigationbar__title">{t("Item detailes")}</div>
              </div>
              <div className="navigationbar__right">
              </div>
            </div>

            <div className="heading mb-2">{t("T-Shirt exchange")}</div>
            {/*<div className="text-secondary mb-6">{t("Returned Items")}</div>*/}

            {gears
              .filter((x) => x.isTshirt)
              .filter(
                (x, index, array) =>
                  array.findIndex(
                    (i) =>
                      i.productId === x.productId &&
                      i.productVariationId === x.productVariationId
                  ) === index
              )
              .sort((a, b) =>
                a.productId !== b.productId
                  ? a.productId - b.productId
                  : (a.productVariationId ?? 0) -
                    (b.productVariationId ?? 0)
              )
              .map((gear, index, array) => (
                <div
                  key={gear.id}
                  className="product-list-card mb-4"
                >
                  <div className="flex gap-2 items-center">
                    <div className="relative">
                      <div className="product-list-card__image">
                        <img src={gear.productImage} alt="package name"/>
                      </div>

                      {gear.variationName && (
                        <div className="product-list-card__variation-name">
                          {gear.variationName}
                        </div>
                      )}
                    </div>
          
                    <div className="product-list-card__title">
                      {gear.productName}
                    </div>

                    <div className="ml-6">
                      <div className="order-product-variation-quantity">
                        <button
                          type="button"
                          className="order-product-variation-quantity__decrement"
                          onClick={() => {
                            if (gear.productVariationId) {
                              modifyReturnedTshirts(
                                gear.productId,
                                gear.productVariationId,
                                false
                              );
                            }
                          }}
                        ></button>
                        <input
                          className="order-product-variation-quantity__input"
                          type="number"
                          value={
                            returnedTshirts.find(
                              (item) =>
                                item.productId === gear.productId &&
                                item.variationId === gear.productVariationId
                            )?.quantity ?? 0
                          }
                          style={{
                            width: `${Math.max(
                              (returnedTshirts.find(
                              (item) =>
                                item.productId === gear.productId &&
                                item.variationId === gear.productVariationId
                            )?.quantity ?? 0).toString().length, 2)}ch`
                          }}
                          disabled={true}
                        />
                        <button
                          type="button"
                          className="order-product-variation-quantity__increment"
                          onClick={() => {
                            if (gear.productVariationId) {
                              modifyReturnedTshirts(
                                gear.productId,
                                gear.productVariationId,
                                true
                              );
                            }
                          }}
                        ></button>
                      </div>
                    </div>
                  </div>
                </div>
              ))}

              <div className="separator-line"></div>

              <div className="heading mt-1 mb-4">{t("Distributed Items")}</div>

            {tShirts
                .filter((tshirt) => isProductInStock(tshirt))
                .map((tshirt) => {
                  //const isProductAvailable = isProductInStock(tshirt);

                  return (
                      <div
                          key={`${tshirt.id}-${tshirt.selectedVariationId}`}
                          className={
                              "product-list-card mb-4 " +
                              (dispatchedTshirts.find((item) => item.productId === tshirt.id)?.quantity
                                  ? "marked "
                                  : "")
                          }
                      >
                        <div className="flex gap-2 justify-between items-center">
                          <div className="flex gap-2 flex-ellipsis-helper">
                            <div className="relative ">
                              <div className="product-list-card__image">
                                <img src={tshirt.image || "https://via.placeholder.com/60"} alt="package name" />
                              </div>
                            </div>

                            <div className="flex-1 flex-ellipsis-helper">
                              <div className="product-list-card__title mb-2">{tshirt.name}</div>
                              <select
                                  className="input-field input-field--small input-field--auto-width"
                                  onChange={(e) => {
                                    let oldQuantity =
                                        dispatchedTshirts.find((item) => item.productId === tshirt.id)?.quantity ?? 0;

                                    setTShirts((prev) => [
                                      ...prev.map((item) => {
                                        if (item.id === tshirt.id) {
                                          item.selectedVariationId = parseInt(e.target.value);
                                        } else {
                                          item.selectedVariationId = null;
                                        }
                                        return item;
                                      }),
                                    ]);

                                    setTimeout(() => {
                                      console.log(oldQuantity);
                                      for (let i = 0; i < oldQuantity; i++) {
                                        modifyDispatchedTshirts(tshirt.id, parseInt(e.target.value), true);
                                        console.log("dispatched", dispatchedTshirts, oldQuantity, i, tshirt.id, parseInt(e.target.value));
                                      }
                                    }, 500);
                                  }}
                                  defaultValue={tshirt.selectedVariationId?.toString() ?? undefined}
                              >
                                <option value="">-</option>
                                {tshirt.variations
                                    .filter((x) => (stocks.find((stock) => stock.variationId === x.id)?.quantity ?? -1) > 0)
                                    .map((variation) => (
                                        <option key={variation.id} value={variation.id}>
                                          {variation.name}
                                        </option>
                                    ))}
                              </select>
                            </div>
                          </div>

                          <div>
                            <div className="order-product-variation-quantity">
                              <button
                                  type="button"
                                  className="order-product-variation-quantity__decrement"
                                  onClick={() => {
                                    if (!tshirt.selectedVariationId) return;

                                    const newQuantity = dispatchedTshirts.find(
                                        (item) => item.productId === tshirt.id && item.variationId === tshirt.selectedVariationId
                                    )?.quantity ?? 0;

                                    modifyDispatchedTshirts(tshirt.id, tshirt.selectedVariationId, false);

                                    if (newQuantity - 1 <= 0) {
                                      setTShirts((prev) =>
                                          prev.map((item) =>
                                              item.id === tshirt.id ? {...item, selectedVariationId: null} : item
                                          )
                                      );
                                    }
                                  }}
                              ></button>
                              <input
                                  className="order-product-variation-quantity__input"
                                  type="number"
                                  value={
                                      dispatchedTshirts.find(
                                          (item) =>
                                              item.productId === tshirt.id &&
                                              item.variationId === tshirt.selectedVariationId
                                      )?.quantity ?? 0
                                  }
                                  style={{
                                    width: `${Math.max(
                                        (
                                            dispatchedTshirts.find(
                                                (item) =>
                                                    item.productId === tshirt.id &&
                                                    item.variationId === tshirt.selectedVariationId
                                            )?.quantity ?? 0
                                        ).toString().length,
                                        2
                                    )}ch`,
                                  }}
                                  disabled={true}
                              />
                              <button
                                  type="button"
                                  className="order-product-variation-quantity__increment"
                                  onClick={() => {
                                    let selectedVariation = tshirt.selectedVariationId;

                                    if (!selectedVariation) {
                                      selectedVariation =
                                          tshirt.variations.find(
                                              (x) => (stocks.find((stock) => stock.variationId === x.id)?.quantity ?? -1) > 0
                                          )?.id;

                                      if (!selectedVariation) {
                                        return;
                                      }

                                      setTShirts((prev) =>
                                          prev.map((item) =>
                                              item.id === tshirt.id ? {
                                                ...item,
                                                selectedVariationId: selectedVariation
                                              } : item
                                          )
                                      );
                                    }

                                    modifyDispatchedTshirts(tshirt.id, selectedVariation, true);
                                  }}
                              ></button>
                            </div>
                          </div>
                        </div>
                      </div>
                  );
                })}


            <div className="flex items-center gap-4">
              <div className="flex-1">
                <button
                    type="button"
                    className="button button--light"
                    onClick={() => {
                      setReturnedTshirts([]);
                      setDispatchedTshirts([]);
                      setShowTshirtExchange(false);
                    }}
                >
                  {t("Cancel")}
                </button>
              </div>
              <div className="flex-1">
                <button
                    type="button"
                    className={`button ${isSaveDisabled ? "button--disabled" : ""}`}
                    disabled={isSaveDisabled}
                    onClick={() => {
                      if (isSaveDisabled) return;
                      setShowTshirtExchange(false);
                    }}
                >
                  {t("Save")}
                </button>
                </div>
              </div>

            </div>
          </div>   
        </div>
     


      {maxTshirtsCount.maxTshirts + maxTshirtsCount.returnModifier > 0 ? (
          <div className={`product-list-card mb-4 ${
              returnedTshirts.length > 0 || dispatchedTshirts.length > 0 ? "marked" : ""
          }`}>
            <div className="relative">
              <div className="flex gap-2">
                <div className="product-list-card__image">
                  <img src={TshirtIcon} alt="package name"/>
                </div>
                <div className="flex justify-between items-center w-full">
                  <div className="product-list-card__title">
                    {t("T-Shirts")}
                  </div>
                  <div>
                    <div className={"status open"}>
                      {returnedTshirts.length > 0 || dispatchedTshirts.length > 0 || 1 ? (
                          <button
                              type="button"
                              className="product-list-card__check needtocheck"
                              onClick={() => setShowTshirtExchange(true)}
                          >
                            <CheckIcon/>
                          </button>
                      ) : (
                        <div className="exchange-list-card__exchange-type-icon-holder">
                          <div
                              className="exchange-list-card__exchange-type-icon"
                              onClick={() => setShowTshirtExchange(true)}
                          >
                            <ExchangeLifecycleIcon/>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>

                  {/*
                  <div className="exchange-list-card__exchange-type-icon">
                    <ExchangeLifecycleIcon/>
                  </div>
                  */}

                  <div className="exchange-list-card__exchange-type-icon-holder">
                    <Popover defaultPosition={"left"} text={t('Eligible exchange')}>
                      <div className="exchange-list-card__exchange-type-icon">
                        <ExchangeLifecycleIcon/>
                      </div>
                    </Popover>
                  </div>
                </div>
              </div>
            </div>
          </div>
      ) : null}


    </>
  );
};

export default ExchangeTshirts;
